import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import MenuLateral from "./MenuLateral";
import LogoutIcon from '@mui/icons-material/Logout';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import keycloak from '../keycloak';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

let tempo = 0;
let count = 0
export default function MainAppBar(props) {

  const { setBusca } = props;

  const usuario = keycloak.tokenParsed?.preferred_username || keycloak.tokenParsed?.email || "";

  const handleMenu = () => {
    keycloak.logout({ redirectUri: window.location.origin });
  };


  const handleOnChange = (e) => {
    let now = new Date();

    let timeDiff = now - tempo; //in ms

    if (timeDiff > 800) {
      count++;

      makeBusca();
    }

    tempo = now;

    // setBusca(e.target.value)
  }

  function makeBusca(timeDiff) {
    if (count > 1) return;

    setTimeout(() => {
      let now = new Date();
      let timeDiff = now - tempo; //in ms
      if (timeDiff > 800) {
        count++;
        let txt = document.getElementById("campo").value;
        console.log("doing ", timeDiff, txt);
        setBusca(txt);
        count = 0;
      } else {
        makeBusca();
      }
    }, "300")
  }
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static">
          <Toolbar>

            <MenuLateral />

            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
            >
              Very-LiciNet
            </Typography>
            <Search>
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Search…"
                inputProps={{ 'aria-label': 'search' }}
                onChange={handleOnChange}
                id="campo"
              />
            </Search>
            {usuario && (
              <Typography
                variant="body2"
                noWrap
                sx={{ display: { xs: 'none', sm: 'block' }, marginLeft: 1, marginRight: 1 }}
              >
                {usuario}
              </Typography>
            )}
            <div>
              <IconButton
                size="large"
                aria-label="sair"
                title="Sair"
                onClick={handleMenu}
                color="inherit"
              >
                <LogoutIcon />
              </IconButton>
            </div>


          </Toolbar>
        </AppBar>
      </Box>
    </LocalizationProvider>
  );
}
